const disableScrollClass = 'disable-body-scroll';
const body = document.body;
const html = document.documentElement;
let scrollPosition = 0;

export function disableBgScrollOnIphones() {
  scrollPosition = window.scrollY; // Save the current scroll position

  // Lock the body scroll by setting position fixed and top
  document.body.style.position = 'fixed';
  document.body.style.top = `-${scrollPosition}px`;
  document.body.style.width = '100%'; // Prevent horizontal scrollbar
}

export function enableBgScrollOnIphones() {
  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.width = '';

  window.scrollTo(0, scrollPosition); // Restore the scroll position

  scrollPosition = 0; // Reset scroll position
}

export function disableBodyScroll() {
  if (html.classList.contains(disableScrollClass)) return;

  const scrollY = window.scrollY; // Capture the current scroll position
  const scrollBarWidth = `${
    window.innerWidth - document.documentElement.clientWidth
  }px`;

  html.style.paddingRight = scrollBarWidth;
  html.style.setProperty('--scroll-bar-width', scrollBarWidth);
  html.style.setProperty('--scroll-progress', `${scrollY}`); // Store exact scroll position
  html.setAttribute('data-scroll-progress', scrollY); // Save scrollY to a data attribute
  html.classList.add(disableScrollClass);

  body.classList.add('fixed', 'overflow-hidden', 'w-adjust-for-scrollbar');
  body.style.top = `-${scrollY}px`; // Use negative scroll position to offset fixed body
}

export function enableBodyScroll() {
  const scrollY = parseInt(
    html.getAttribute('data-scroll-progress') || '0',
    10,
  );

  html.classList.remove(disableScrollClass);
  html.style.setProperty('--scroll-bar-width', '');
  html.style.setProperty('--scroll-progress', '');
  html.style.paddingRight = '';

  body.classList.remove('fixed', 'overflow-hidden', 'w-adjust-for-scrollbar');
  body.style.top = '';
  window.scrollTo(0, scrollY); // Restore the page's previous scroll position
}
